import dayjs from 'dayjs';

const ONE_LAKH = 100_000;
const ONE_CRORE = 10_000_000;

export function getDefaultReportDateRange() {
  return [dayjs().startOf('month'), dayjs()];
}

export function toReportQueryParams(range, scopeUserId) {
  if (!range?.[0] || !range?.[1]) return null;
  return {
    startDate: range[0].format('YYYY-MM-DD'),
    endDate: range[1].format('YYYY-MM-DD'),
    scopeUserId: scopeUserId || 'all',
  };
}

export function formatIndianCount(value) {
  return new Intl.NumberFormat('en-IN').format(Number(value) || 0);
}

export function formatRevenue(value) {
  const amount = Number(value) || 0;
  const abs = Math.abs(amount);
  const sign = amount < 0 ? '-' : '';

  if (abs >= ONE_CRORE) {
    return `${sign}₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(abs / ONE_CRORE)} Cr`;
  }
  if (abs >= ONE_LAKH) {
    return `${sign}₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(abs / ONE_LAKH)} L`;
  }
  return `${sign}₹${formatIndianCount(abs)}`;
}

export function formatWeekLabel(weekStart) {
  if (!weekStart) return '';
  return dayjs(weekStart).format('D MMM');
}

export function formatReportDateTime(value) {
  if (!value) return '';
  return dayjs(value).format('D MMM YYYY');
}

export function filenameFromContentDisposition(header, fallback) {
  const value = String(header || '');
  const quoted = value.match(/filename="([^"]+)"/i);
  if (quoted?.[1]) return quoted[1];
  const plain = value.match(/filename=([^;]+)/i);
  if (plain?.[1]) return plain[1].trim().replace(/^["']|["']$/g, '');
  const utf8 = value.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8?.[1]) {
    try {
      return decodeURIComponent(utf8[1].trim());
    } catch {
      return utf8[1].trim();
    }
  }
  return fallback;
}

export function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export async function readBlobErrorMessage(error, fallback = 'Download failed') {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const text = await data.text();
      const parsed = JSON.parse(text);
      return parsed?.message || fallback;
    } catch {
      return fallback;
    }
  }
  return error?.response?.data?.message || error?.message || fallback;
}

export function isJsonBlob(blob, contentType = '') {
  if (String(contentType).includes('application/json')) return true;
  return Boolean(blob?.type && blob.type.includes('application/json'));
}
